var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('aml.heading')))]),_c('div',{staticClass:"p-4 bg-white border-light rounded shadow"},[_c('legal-info-form',{attrs:{"client-type":_vm.clientType,"defaults":_vm.legalInfo || {}},on:{"submit":_vm.onSubmit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }